import React from 'react';
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {dateRenderer} from "../../services/formatSvc";
import ExpertReportContent from "./ExpertReportContent";
import FileInput from "../UI/upload/FileInput";
import style from "../project/Widgets/Articles/style.module.less";
import { statusKeys as PS } from '../../helpers/projReportHelper';
import CloseProjContent from "./CloseProjContent";

const CloseProjCard = ({closeProjValue,onChangeFile,onCloseDataChange,onCloseProj,status}) => {

    const handleChangeFiles = (newFiles) => {
        onCloseDataChange('closeFiles',newFiles);
    };

    const handleCloseDateChange = ({ target }) => {
        onCloseDataChange('closedOn',target.value);
    };
    return (
        <Card>
            <Card.Header as={Card.Title} className="p-4">
                Закрытие проекта
            </Card.Header>
            <Card.Body className="p-4">
                <CloseProjContent closeData={closeProjValue} callbacks={{handleCloseDateChange,handleChangeFiles}}/>
                {<Button variant={'danger'} onClick={onCloseProj}>Закрыть проект</Button>}
            </Card.Body >

        </Card>

    );
};

export default CloseProjCard;